import ChannelLabel from '@op/components/ChannelLabel';
import MultipleSelect, {
  IMultipleSelectType,
} from '../components/MultipleSelect';
import { TComponentConfig } from '../types';
import { getMultipleSelectDefaultValue } from '../utils';
import React from 'react';
import { MultipleSelectButton } from '../components/MultipleSelect/MultipleSelectButton';

function dealwithCondOptions(condInfo: any, key: string) {
  const data = condInfo[key];
  return data.map((item: any) => ({
    value: item.value,
    text: item.label_en,
    textCn: item.label_zh,
  }));
}

function defaultValueFunc(filterValue: any, props: IMultipleSelectType) {
  const { options, valueKeys: key } = props;
  const list = options || [];
  return getMultipleSelectDefaultValue(
    filterValue,
    key,
    list,
    list.map((item) => item.value),
  );
}

function backValueFunc(filterValue: any, props: IMultipleSelectType) {
  const { valueKeys: key, options } = props;
  const list = (options || []).map((item) => item.value);
  const values = filterValue?.[key] || [];
  if (values.length === list.length) {
    return { [key]: [] };
  }
  return { [key]: values };
}

export const MemeType: TComponentConfig<IMultipleSelectType> = {
  Component: MultipleSelect,
  ButtonComponent: MultipleSelectButton,
  defaultValue: defaultValueFunc,
  backValue: backValueFunc,
  condDealwith: dealwithCondOptions,
  requestKey: 'memes_config_types',
  props: {
    title: 'Meme Type',
    titleCn: '热梗类型',
    valueKeys: 'meme_types',
    options: [],
    listHeight: 400,
    matchButtonWidth: false,
    maxShow: 1
  },
};

export const MemeElements: TComponentConfig<IMultipleSelectType> = {
  Component: MultipleSelect,
  ButtonComponent: MultipleSelectButton,
  defaultValue: defaultValueFunc,
  backValue: backValueFunc,
  requestKey: 'memes_config_elements',
  condDealwith: dealwithCondOptions,
  props: {
    title: 'Meme Elements',
    titleCn: '热梗元素',
    valueKeys: 'meme_elements',
    options: [],
    listHeight: 400,
    matchButtonWidth: false,
    maxShow: 1
  },
};

export const MemeRegion: TComponentConfig<IMultipleSelectType> = {
  Component: MultipleSelect,
  ButtonComponent: MultipleSelectButton,
  defaultValue: defaultValueFunc,
  backValue: backValueFunc,
  condDealwith: dealwithCondOptions,
  requestKey: 'memes_config_regions',
  props: {
    title: 'Region',
    titleCn: '区域',
    valueKeys: 'regions',
    options: [],
    listHeight: 400,
    matchButtonWidth: false,
    maxShow: 1,
  },
};

export const MemeChannel: TComponentConfig<IMultipleSelectType> = {
  Component: MultipleSelect,
  ButtonComponent: MultipleSelectButton,
  defaultValue: defaultValueFunc,
  backValue: backValueFunc,
  requestKey: 'memes_config_channels',
  condDealwith: (data) => {
    const list = data?.memes_config_channels || [];

    return list.map((item: string) => ({ text: item, value: item }));
  },
  props: {
    title: 'Channel',
    titleCn: '渠道',
    valueKeys: 'channels',
    itemRender: (item: any) => (
      <ChannelLabel
        iconStyle={{ width: 18, height: 18 }}
        channel_name={item?.value as 'tiktok'}
        showText={false}
      />
    ),
    optionsItemRender: (item: any) => (
      <ChannelLabel
        iconStyle={{ width: 18, height: 18 }}
        channel_name={item?.value as 'tiktok'}
      />
    ),
    options: [],
    maxShow: 6,
    hideComma: true,
    showItemsThreshold: 6
  },
};
